import { recaptchaSiteKeyV3 } from "../configs/VD-config";
import { FAILED_TO_GET_TOKEN_STRING } from "../interaction/recaptcha";

/**
 * Executes Google reCAPTCHA v3 and returns the token.
 *
 * @param {string} action
 * @returns {Promise<string>} token or fallback error string
 */
export async function getRecaptchaToken(action) {
    try {
        return await grecaptcha.execute(recaptchaSiteKeyV3, { action });
    } catch (ex) {
        return `${FAILED_TO_GET_TOKEN_STRING}|${ex.message}`;
    }
}
